import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import {push as changeURL, replace as replaceURL} from 'react-router-redux';

import EndingPage from '../EndingPage';
import store from '~/store';
import mapDispatch from '~/misc/mapDispatch';
import {modalChange} from '~/modules/modal/actions';
import * as modes from '~/modules/modal/modes';
import {getPaymentInfo, payOrderAction} from '~/modules/hp/actions';
import Spinner from '~/components/common/Spinner';
import {track} from '~/misc/metrics';
import {getUrlQeury} from '~/misc/formatUrlquery';
import css from './index.css';
import sharedCSS from '~/components/shared.css';
import accountPageCss from '../MyAccount/share.css';
class PendingPayment extends React.Component {
  constructor(props) {
    super(props);
    this.jugdeRoute = this.jugdeRoute.bind(this);
  }

  componentWillMount() {
    track('payment', {'pending - payment': 1});
    const orderId = getUrlQeury() ? getUrlQeury().order_id : '';
    const token = this.props.user.token;

    if (!orderId) {
      this.props.gotoHp();
    } else if (!token) {
      this.props.login();
    } else if (this.props.user.id) {
      this.jugdeRoute();
    }
  }

  componentWillReceiveProps(nextProps) {
    // 解决当前页面登出后数据不更新的问题，
    if (this.props.user.id && (this.props.user.id !== nextProps.user.id)) {
      this.props.gotoRoot();
    }

    if (!this.props.user.id && nextProps.user.id) {
      this.jugdeRoute();
    }
    // 判断order_id 为已支付跳转去成功页面
    if (isEmpty(this.props.hp.pay.data) && !isEmpty(nextProps.hp.pay.data)) {
      const query = getUrlQeury();
      this.props.goToResult({
        cycle: query.cycle,
        level: query.level,
        source: query.source
      });
    }
    if (isEmpty(this.props.hp.paymentInfo.data)
      && !isEmpty(nextProps.hp.paymentInfo.data)
      && (nextProps.hp.paymentInfo.data[0].status === 'success_paid')
    ) {
      const query = getUrlQeury();
      this.props.goToResult(query.source);
    } else if (nextProps.hp.paymentInfo.status === 'success' && isEmpty(nextProps.hp.paymentInfo.data)) {
      this.props.gotoRoot();
    }
  }

  render() {
    const pageInfo = isEmpty(this.props.hp.createOrder.data) ? this.props.hp.paymentInfo : this.props.hp.createOrder;

    return (
      <div className={cs(sharedCSS.widewrap, 'pay-content')}>
        <div className={cs(sharedCSS.wideStretchable, css.wrap)}>
          <div className={cs(css.content)}>
            { this.renderContent(pageInfo) }
          </div>
        </div>
      </div>
    );
  }

  renderContent(pageInfo) {
    const token = this.props.user.token;
    const paymentInfo = Array.isArray(pageInfo.data) ? pageInfo.data[0] : pageInfo.data;
    const payInfo = this.props.hp.pay;

    if (!token) {
      return (
        <div className={cs(css.removeBg, css.center)}>
          please <span onClick={this.props.login}>login</span> or <span onClick={this.props.signup}>sign up</span>
        </div>
      );
    }
    if (pageInfo.error) {
      return (
        <div className={cs(accountPageCss.viewH, css.center)} onClick={this.jugdeRoute}>
          {pageInfo.error}
        </div>
      );
    }

    if (!isEmpty(pageInfo.data) && paymentInfo.status !== 'success_paid') {
      // const productMount = paymentInfo.product.total ? paymentInfo.product.total : 0;

      return (
        <div>
          <EndingPage
            payInfo={payInfo}
            user={this.props.user}
            query={getUrlQeury()}
            account={this.props.account}
            orderInfo={paymentInfo}
            type='pending'
            actionFn={payOrderAction}
          />
        </div>
      );
    }
    return (
      <div className={sharedCSS.viewH}>
        <div className={cs(accountPageCss.spinnerLine)}>
          <div className={cs(accountPageCss.spinner, css.marginCenter)}>
            <Spinner scalable={true}/>
          </div>
        </div>
      </div>
    );
  }

  jugdeRoute() {
    const query = getUrlQeury();
    if (!isEmpty(query) && query.order_id) {
      store.dispatch((dispatch, getState) => getPaymentInfo(dispatch, getState, query));
      this.setState({
        query: query,
      });
    }
  }
}

export default connect(({user, routing, account, hp}) => ({user, routing, account, hp}), mapDispatch({
  login: () => modalChange(modes.LOGIN, 'user-account'),
  signup: () => modalChange(modes.SIGNUP, 'user-account'),
  gotoHp: () => changeURL('/hp'),
  goToResult: (props, { cycle ,level, source}) => replaceURL(`/result?cycle=${cycle}&level=${level}${source ? ("&source="+source) : ""}`),
  gotoRoot: () => changeURL('/'),
}))(PendingPayment);



// WEBPACK FOOTER //
// ./src/components/pages/PendingPayment/index.js